<template>
  <b-modal
    id="modalCreateEditFormaPagamento"
    size="xl"
    :title="textModal"
    title-class="font-18"
    hide-footer
    no-close-on-backdrop
    @hidden="$emit('closeModal', false)"
  >
    <form @submit.prevent="save">
      <div class="form-row">
        <div class="form-group col-sm-6">
          <label>Descricao: <span class="text-danger">*</span></label>
          <input
            type="text"
            class="form-control"
            :class="{ 'is-invalid': $v.formaPagamento.descricao.$error }"
            placeholder="Descrição da forma de pagamento"
            v-model="$v.formaPagamento.descricao.$model"
          />
          <span
            v-if="!$v.formaPagamento.descricao.required"
            class="invalid-feedback"
          >
            O campo é obrigatório
          </span>
          <span
            v-if="!$v.formaPagamento.descricao.minLength"
            class="invalid-feedback"
          >
            A descrição deve possuir pelo menos 3 caracteres
          </span>
        </div>
      </div>
      <div v-if="formaPagamentoId" class="form-row">
        <div class="form-group col-sm-6">
          <p>Status: <span class="text-danger">*</span></p>
          <div class="form-check form-check-inline">
            <input
              type="radio"
              class="form-check-input"
              id="statusInativo"
              value="0"
              v-model="formaPagamento.status"
            />
            <label class="form-check-label" for="statusInativo">
              Inativo
            </label>
          </div>
          <div class="form-check form-check-inline">
            <input
              type="radio"
              class="form-check-input"
              id="statusAtivo"
              value="1"
              v-model="formaPagamento.status"
            />
            <label class="form-check-label" for="statusAtivo"> Ativo </label>
          </div>
        </div>
      </div>
      <hr />
      <div class="modal-footer-custom">
        <button
          type="button"
          class="btn btn-secondary"
          title="Cancelar"
          @click="$emit('closeModal', false)"
        >
          Cancelar
        </button>
        <button
          type="submit"
          class="btn btn-primary"
          :title="textModal"
          :disabled="$v.$invalid || disableButton"
        >
          <i
            v-if="disableButton"
            class="spinner-grow spinner-grow-custom text-wither"
          />
          <span v-else>{{ textModal }}</span>
        </button>
      </div>
    </form>
  </b-modal>
</template>

<script>
import { required, minLength } from 'vuelidate/lib/validators'

export default {
  name: 'CreateEditFormaPagamentoModal',
  props: {
    formaPagamentoId: {
      type: String,
      default: null,
    },
  },

  data() {
    return {
      formaPagamento: {
        descricao: '',
      },
      disableButton: false,
    }
  },

  computed: {
    textModal() {
      return this.formaPagamentoId ? 'Atualizar' : 'Cadastrar'
    },
  },

  methods: {
    async getFormaPagamento() {
      try {
        this.formaPagamento = await this.$store.dispatch(
          'getFormaPagamento',
          this.formaPagamentoId,
        )
        this.$bvModal.show('modalCreateEditFormaPagamento')
      } catch (error) {
        if (error && error.message) {
          this.$root.$bvToast.toast(error.message, {
            title: 'Atenção!',
            variant: 'warning',
            solid: true,
          })
        } else {
          this.$root.$bvToast.toast(
            'Não foi possível se conectar ao servidor.',
            {
              title: 'Erro!',
              variant: 'danger',
              solid: true,
            },
          )
        }
        this.$emit('closeModal', false)
      }
    },

    async save() {
      if (!this.$v.$invalid) {
        this.disableButton = true
        try {
          let response = null
          if (this.formaPagamentoId) {
            response = await this.$store.dispatch('updateFormaPagamento', {
              id: this.formaPagamentoId,
              formaPagamento: this.formaPagamento,
            })
          } else {
            response = await this.$store.dispatch(
              'saveFormaPagamento',
              this.formaPagamento,
            )
          }
          this.disableButton = false
          this.$root.$bvToast.toast(response.message, {
            title: 'Sucesso!',
            variant: 'success',
            solid: true,
          })
          this.$emit('closeModal', true)
        } catch (error) {
          this.disableButton = false
          if (error && error.message) {
            this.$root.$bvToast.toast(error.message, {
              title: 'Atenção!',
              variant: 'warning',
              solid: true,
            })
          } else {
            this.$root.$bvToast.toast(
              'Não foi possível se conectar ao servidor.',
              {
                title: 'Erro!',
                variant: 'danger',
                solid: true,
              },
            )
          }
        }
      }
    },
  },

  validations: {
    formaPagamento: {
      descricao: {
        required,
        minLength: minLength(3),
      },
    },
  },

  mounted() {
    if (this.formaPagamentoId) {
      this.getFormaPagamento()
    } else {
      this.$bvModal.show('modalCreateEditFormaPagamento')
    }
  },
}
</script>
